// Agrupa el historial diario de calorías/macros en cubos más grandes
// cuando el rango de tiempo seleccionado es largo: a 6 meses vista,
// una barra por día es ilegible, así que se promedia por semana o por mes.
export function bucketModeFor(rangeWeeks) {
  if (rangeWeeks <= 2) return 'day'
  if (rangeWeeks <= 12) return 'week'
  return 'month'
}

function bucketKeyAndLabel(fecha, mode) {
  const d = new Date(fecha)
  if (mode === 'week') {
    const dow = (d.getDay() + 6) % 7 // 0 = lunes
    const monday = new Date(d)
    monday.setDate(d.getDate() - dow)
    return {
      key: monday.toISOString().split('T')[0],
      label: monday.toLocaleDateString('es', { day: '2-digit', month: 'short' }),
      fecha: monday.toISOString().split('T')[0],
    }
  }
  if (mode === 'month') {
    return {
      key: `${d.getFullYear()}-${d.getMonth()}`,
      label: d.toLocaleDateString('es', { month: 'short', year: '2-digit' }),
      fecha,
    }
  }
  return { key: fecha, label: d.toLocaleDateString('es', { day: '2-digit', month: 'short' }), fecha }
}

export function aggregateHistory(data, mode) {
  if (mode === 'day' || !data?.length) return data ?? []

  const groups = new Map()
  for (const d of data) {
    const { key, label, fecha } = bucketKeyAndLabel(d.fecha, mode)
    if (!groups.has(key)) groups.set(key, { label, fecha, items: [] })
    groups.get(key).items.push(d)
  }

  return Array.from(groups.values())
    .sort((a, b) => new Date(a.fecha) - new Date(b.fecha))
    .map(g => {
      // Los días sin comidas registradas no cuentan en la media del periodo.
      const valid = g.items.filter(i => i.kcal > 0)
      const hasV = g.items[0].v !== undefined
      if (valid.length === 0) {
        return { fecha: g.fecha, label: g.label, kcal: 0, prot: 0, gras: 0, carb: 0, sinDatos: true, ...(hasV ? { v: null } : {}) }
      }
      const n = valid.length
      const avg = k => Math.round(valid.reduce((s, i) => s + i[k], 0) / n)
      return {
        fecha: g.fecha, label: g.label, kcal: avg('kcal'), prot: avg('prot'), gras: avg('gras'), carb: avg('carb'),
        ...(hasV ? { v: avg('v'), sinDatos: false } : {}),
      }
    })
}
